<template lang="pug">
div(v-if="hasImovel")
  app-divider(label="Dados gerais")
  div(v-if="hasEndereco")
    el-row(:span="24")
      el-col(:span="12")
        app-display(
          id="BAIRRO",
          label="Bairro:",
          :content="exibirCampoComum(cadastroOriginal.imovel.endereco, 'bairro')",
          :class = "compararImovelReurb.mudouEnderecoImovel.mudouBairro ? 'text': '' "
        )
      el-col(:span="12")
        app-display(
          id="ENDERECO",
          label="Endereço:",
          :content="exibirCampoComum(cadastroOriginal.imovel.endereco, 'loteamentoVila')",
          :marginBottom="true",
          :class = "compararImovelReurb.mudouEnderecoImovel.mudouLoteamantoVila ? 'text': '' "
        )
      el-col(:span="12")
          app-display(
            id="NUMERO",
            label="Número:",
            :content="exibirCampoComum(cadastroOriginal.imovel.endereco, 'numero') || '-'",
            :class = "compararImovelReurb.mudouEnderecoImovel.mudouNumero ? 'text': '' "
          )
      el-col(:span="12")
        app-display(
          id="COMPLEMENTO",
          label="Complemento:",
          :content="exibirCampoComum(cadastroOriginal.imovel.endereco, 'complemento') || '-'",
          :marginBottom="true",
          :class = "compararImovelReurb.mudouEnderecoImovel.mudouComplemento ? 'text': '' "
        )
      el-col(:span="12")
        app-display(
          v-if="!isReurb"
          id="AREA_IMOVEL",
          label="Área do imóvel (m²):",
          :content="exibirCampoComum(cadastroOriginal.imovel, 'area') || '-'",
          :marginBottom="true",
          :class = "compararImovelReurb.mudouArea ? 'text': '' "
        )
    el-row(:span="24")
      el-col(:span="12")
        app-display(
          id="LOTE",
            label="Lote:",
            :content="exibirCampoComum(cadastroOriginal.imovel.endereco, 'lote') || '-'",
            :class = "compararImovelReurb.mudouEnderecoImovel.mudouLote ? 'text': '' "
          )
      el-col(:span="12")
        app-display(
          id="QUADRA",
          label="Quadra:",
          :content="exibirCampoComum(cadastroOriginal.imovel.endereco, 'quadra') || '-'",
          :class = "compararImovelReurb.mudouEnderecoImovel.mudouQuadra ? 'text': '' "
        )
    el-row(:span="24")
      el-col(:span="12")
        app-display(
          id="PERIMETRO_LOTE",
          :label="'Perímetro do lote (m²):'",
          :content="exibirCampoComum(cadastroOriginal.imovel, 'areaConstruida') || '-'",
          :class = "compararImovelReurb.mudouAreaConstruida ? 'text': '' "
        )
      el-col(:span="12")
        app-display(
          v-if="isReurb"
          id="AREA_LOTE",
          label="Área do lote (m²):",
          :content="exibirCampoComum(cadastroOriginal.imovel, 'area') || '-'",
          :marginBottom="true",
          :class = "compararImovelReurb.mudouArea ? 'text': '' "
        )
      el-col(:span="12")
        app-display(
          id="BEM_UNICO",
          label="É bem único:",
          :content="cadastroOriginal.imovel.bemUnico ? 'Sim' : 'Não'",
          :class = "cadastroOriginal.imovel.bemUnico ? 'text': '-' "
        )
      el-col(:span="12")
        app-display(
          id="MATRICULA",
          label="Possui matrícula:",
          :content="getPossuiMatricula()",
          :class = "cadastroOriginal.imovel.possuiMatricula ? 'text': '-' "
        )
  app-divider(label="Características gerais do imóvel")
  div(class="margin-top-10")
    el-row(:span="24")
      el-col(:span="12")
        app-display(
          id="OCUPACAO",
          label="Ocupação:",
          :content="exibirValor(cadastroOriginal.imovel.ocupacao , 'ocupacao')"
          :class = "compararImovelReurb.mudouOcupacao ? 'text': '' "
        )
      el-col(:span="12")
        app-display(
          id="TIPO",
          label="Tipo:",
          :content="exibirValor(cadastroOriginal.imovel.estadoImovel , 'estadoImovel')"
          :marginBottom="true",
          :class = "compararImovelReurb.mudouEstadoImovel ? 'text': '' "
        )
    el-row(:span="24")
      el-col(:span="12")
        app-display(
          id="DOMINIALIDADE",
          label="Dominialidade:",
          :content="exibirValor(cadastroOriginal.imovel.dominialidade , 'dominilidade')"
          :class = "compararImovelReurb.mudouDominilidade ? 'text': '' "
        )
      el-col(:span="12", v-if="cadastroOriginal.imovel.regimeUsos && cadastroOriginal.imovel.regimeUsos.length > 0")
        app-display-multiple(
          id="REGIME_USOS",
          label="Regime de uso:",
          :content="exibirValores(cadastroOriginal.imovel.regimeUsos , 'regimeUsos')",
          :marginBottom="true",
          :class = "compararImovelReurb.mudouRegimeUso ? 'text': '' "
        )
      el-col(:span="12", v-if="cadastroOriginal.imovel.regimeUso")
        app-display(
          id="REGIME_USO",
          label="Regime de uso:",
          :content="exibirValor(cadastroOriginal.imovel.regimeUso , 'regimeUso')",
          :marginBottom="true",
          :class = "compararImovelReurb.mudouRegimeUso ? 'text': '' "
        )

  app-divider(v-if="hasTerreno" label="Características do terreno")
  div(v-if="hasTerreno", class="margin-top-10")
    el-row(:span="24")
      el-col(:span="12")
        app-display(
          id="LOCALIZACAO",
          label="Localização:",
          :content="exibirValor(cadastroOriginal.imovel.terreno.localizacao , 'localizacao')"
          :class = "compararImovelReurb.mudouTerreno.mudouLocalizacao ? 'text': '' "
        )
      el-col(:span="12", v-if="cadastroOriginal.imovel.terreno.delimitacao")
        app-display(
          id="DELIMITACAO",
          label="Delimitação:",
          :content="exibirValor(cadastroOriginal.imovel.terreno.delimitacao , 'delimitacao')",
          :marginBottom="true",
          :class = "compararImovelReurb.mudouTerreno.mudouDelimitacao ? 'text': '' "
        )
      el-col(:span="12", v-if="cadastroOriginal.imovel.terreno.delimitacoes")
        app-display-multiple(
          id="DELIMITACOES",
          label="Delimitação:",
          :content="exibirValores(cadastroOriginal.imovel.terreno.delimitacoes , 'delimitacoes')",
          :marginBottom="true",
          :class = "compararImovelReurb.mudouTerreno.mudouDelimitacaos ? 'text': '' "
        )
    el-row(:span="24")
      el-col(:span="12")
        app-display(
          id="CALCADA_EXTERNA",
          label="Calçada externa:",
          :content="exibirValor(cadastroOriginal.imovel.terreno.calcadaExterna , 'calcadaExterna')",
          :marginBottom="true",
          :class = "compararImovelReurb.mudouTerreno.mudouCalcadaExterna ? 'text': '' "
        )
      el-col(:span="12")
        app-display(
          id="QUINTAL_AREA_LIVRE",
          label="Quintal área livre:",
          :content="exibirValor(cadastroOriginal.imovel.terreno.quintalAreaLivre , 'quintalAreaLivre')",
          :marginBottom="true",
          :class = "compararImovelReurb.mudouTerreno.mudouQuintalAreaLivre ? 'text': '' "
        )
  app-divider(v-if="hasUnidade" label="Uso da unidade")
  div(v-if="hasUnidade", class="margin-top-10")
    el-row(:span="24")
      el-col(:span="12")
        app-display-multiple(
          id="USO_SOLO",
          label="Uso do solo:",
          :content="exibirValores(cadastroOriginal.imovel.unidade.usoSolos , 'usoSolos')"
          :class = "compararImovelReurb.mudouUnidade.mudouUsoSolos ? 'text': '' "
        )
    el-row(:span="24")
      el-col(:span="12")
        app-display(
          id="OUTRO_USO_SOLO",
          label="Especificação:",
          :content="cadastroOriginal.imovel.unidade.outroUsoSolo"
          :class = "compararImovelReurb.mudouUnidade.mudouOutroUsoSolo ? 'text': '' "
        )

  app-divider(v-if="hasConstrucao" label="Características externas da construção")
  div(v-if="hasConstrucao", class="margin-top-10")
    el-row(:span="24")
      el-col(:span="12")
        app-display-multiple(
          id="COBERTURA",
          label="Cobertura:",
          :content="exibirValores(cadastroOriginal.imovel.construcao.coberturas , 'coberturas')"
          :class = "compararImovelReurb.mudouConstrucao.mudouCoberturas ? 'text': '' "
        )
      el-col(:span="12")
        app-display-multiple(
          id="ESTRUTURA_PAREDE",
          label="Estrutura (parede):",
          :content="exibirValores(cadastroOriginal.imovel.construcao.estruturas , 'estruturas')"
          :marginBottom="true",
          :class = "compararImovelReurb.mudouConstrucao.mudouEstruturas ? 'text': '' "
        )
        app-display(
          id="OUTRO_ESTRUTURA_PAREDE",
          label="Especificação:",
          :content="cadastroOriginal.imovel.construcao.outroEstrutura"
          :marginBottom="true",
          :class = "compararImovelReurb.mudouConstrucao.mudouOutroEstrutura ? 'text': '' "
        )

  app-divider(v-if="hasConstrucao" label="Características internas da construção")
  div(v-if="hasConstrucao", class="margin-top-10")
    el-row(:span="24")
      el-col(:span="12")
        app-display(
          id="FORNECIMENTO_ENERGIA",
          label="Fornecimento de energia:",
          :content="exibirValor(cadastroOriginal.imovel.construcao.fornecimentoEnergia , 'fornecimentoEnergia')",
          :class = "compararImovelReurb.mudouConstrucao.mudouFornecimentoEnergia ? 'text': '' "
        )
      el-col(:span="12")
        app-display(
          id="NUMERO_COMPARTIMENTOS",
          label="Número de compartimentos:",
          :content="exibirCampoComum(cadastroOriginal.imovel.construcao, 'numCompartimentos') || '-'",
          :class = "compararImovelReurb.mudouConstrucao.mudouNumCompartimentos ? 'text': '' "
        )
      el-col(:span="12")
        app-display(
          id="NUMERO_QUARTOS",
          label="Número de quartos:",
          :content="exibirCampoComum(cadastroOriginal.imovel.construcao, 'numQuartos') || '-'",
          :marginBottom="true",
          :class = "compararImovelReurb.mudouConstrucao.mudouNumQuartos ? 'text': '' "
        )
  app-divider(v-if="hasConstrucao" label="Saneamento básico e meio ambiente")
  div(class="margin-top-10")
    el-row(:span="24")
      el-col(:span="12")
        app-display(
          id="SISTEMA_SANITARIOS",
          label="Sistema do sanitário:",
          :content="exibirValor(cadastroOriginal.imovel.sistemaSanitario, 'sistemaSanitario')",
          :marginBottom="true",
          :class = "compararImovelReurb.mudouSistemaSanitario ? 'text': '' "
        )

      el-col(:span="12")
        app-display-multiple(
          id="DESTINACAO_LIXO",
          label="Destinação do lixo:",
          :content="exibirValores(cadastroOriginal.imovel.destinacaoLixos, 'destinacaoLixos')",
          :class = "compararImovelReurb.mudouDestinacaoLixos ? 'text': '' "
        )
    el-row(:span="24")
      el-col(:span="12")
        app-display-multiple(
          id="TIPO_ABASTECIMENTO_AGUA",
          label="Tipo de abastecimento de água:",
          :content="exibirValores(cadastroOriginal.imovel.abastecimentosAgua, 'abastecimentosAgua')",
          :marginBottom="true",
          :class = "compararImovelReurb.mudouAbastecimentoAgua ? 'text': '' "
        )
  app-divider(label="Declaração de posse do imóvel",  v-if="hasDadosDeclaracaoPosseImovel")
  div(class="margin-top-10" v-if="hasDadosDeclaracaoPosseImovel")
    el-row(:span="24")
      el-col(:span="24")
        app-display(
          id="DECLARACAO_POSSE_IMOVEL",
          :label="'Você possui declaração de posse do imóvel?'",
          :content="hasDeclaracaoPosse ? 'Sim' : 'Não'",
          :class="'text'",
        )
      div(v-if="!hasDeclaracaoPosse && !hasDocumentoDeclaracaoPosse")
        app-display(
          :content="this.messages.TEXTO_DECLARACAO_POSSE_TITULO",
          :class="'text'",
          style="text-align: center; font-weight: bold;"
          )
        app-display(
          :content="this.messages.TEXTO_DECLARACAO_POSSE_1",
          :class="'text'"
          )
        app-display(
          :content="this.messages.TEXTO_DECLARACAO_POSSE_2",
          :class="'text'"
          )
        app-display(
          :content="this.messages.TEXTO_DECLARACAO_POSSE_3",
          :class="'text'"
          )
        app-display(
          :content="this.tempoPosse",
          :class="'text'"
          )
  app-divider(label="Declaração de residência",  v-if="hasDadosDeclaracaoResidencia")
  div(class="margin-top-10" v-if="hasDadosDeclaracaoResidencia")
    el-row(:span="24")
      el-col(:span="24")
        app-display(
          id="DECLARACAO_RESIDENCIA_IMOVEL",
          :label="'Você possui declaração de residência?'",
          :content="cadastroOriginal.imovel.possuiDeclaracaoResidencia ? 'Sim' : 'Não'",
          :class="'text'",
        )
      div(v-if="!cadastroOriginal.imovel.possuiDeclaracaoResidencia && !hasDocumentoDeclaracaoResidencia")
        app-display(
          :content="this.messages.TITULO_DECLARACAO_RESIDENCIA",
          :class="'text'",
          style="text-align: center; font-weight: bold;"
        )
        app-display(
          :content="this.endereco",
          :class="'text'"
        )
        app-display(
          :content="this.messages.TEXTO_DECLARACAO_RESIDENCIA",
          :class="'text'"
        )
        app-display(
          :content="this.messages.TEXTO_DECLARACAO_RESIDENCIA_LEI",
          :class="'text'"
          style="margin-left: 60px;"
        )
        app-display(
          :content="this.messages.TEXTO_DECLARACAO_RESIDENCIA_ASSINATURA",
          :class="'text'"
        )
  app-divider(label="Informações complementares")
  div(class="margin-top-10")
    el-row(:span="24")
      el-col(:span="24")
        app-display(
          id="INFORMACOES_NECESSARIAS",
          label="Informações necessárias (se houver):",
          :content="cadastroOriginal.imovel.observacoesGerais || '-'",
          :class = "compararImovelReurb.mudouObservacoesGerais ? 'text': '' "
        )

</template>

<script>
import AppDisplay from '@/components/AppDisplay'
import AppCollapse from '@/components/AppCollapse'
import AppDivider from '@/components/AppDivider'
import enumImovelReurb from '@/utils/enumDadosImovelMobile'
import AppDisplayMultiple from '@/components/AppDisplayMultiple'
import messages from '../../../constants/messages'

export default {

  components: {
    AppDisplay,
    AppCollapse,
    AppDivider,
    AppDisplayMultiple,
    messages
  },

  mixins: [
    enumImovelReurb
  ],

  data () {
    return {
      endereco: messages.TEXTO_DECLARACAO_RESIDENCIA_ENDERECO.replace('ENDERECO', this.getEnderecoCompleto()),
      messages: messages,
      tempoPosse: messages.TEMPO_POSSE.replace('POSSE', this.cadastroOriginal?.imovel?.tempoPosseImovel || '-')
    }
  },

  props: {
    cadastroOriginal: {
      type: Object,
      required: true
    },
    compararImovelReurb: {
      type: Object,
      required: false
    },
    isReurb: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  computed: {
    hasImovel () {
      return !!this.cadastroOriginal?.imovel
    },
    hasUnidade () {
      return !!this.cadastroOriginal?.imovel?.unidade
    },
    hasTerreno () {
      return !!this.cadastroOriginal?.imovel?.terreno
    },
    hasConstrucao () {
      return !!this.cadastroOriginal?.imovel?.construcao
    },
    hasEndereco () {
      return !!this.cadastroOriginal?.imovel?.endereco
    },
    hasDadosDeclaracaoPosseImovel () {
      return [true, false].includes(this.cadastroOriginal?.imovel?.possuiDeclaracaoPosse)
    },
    hasDadosDeclaracaoResidencia () {
      return [true, false].includes(this.cadastroOriginal?.imovel?.possuiDeclaracaoResidencia)
    },
    hasDeclaracaoPosse () {
      return this.cadastroOriginal?.imovel?.possuiDeclaracaoPosse && !this.cadastroOriginal?.imovel?.tempoPosseImovel
    },
    hasDocumentoDeclaracaoPosse () {
      return this.cadastroOriginal?.imovel?.documentos?.find(documento => documento.nome === 'declaracao_posse_imovel')
    },
    hasDocumentoDeclaracaoResidencia () {
      return this.cadastroOriginal?.imovel?.documentos?.find(documento => documento.nome === 'declaracao_posse_residencia')
    }
  },

  methods: {
    exibirCampoComum (value, campo) {
      if (value) {
        if ((campo === 'area') || (campo === 'areaConstruida')) {
          let numero = value[campo]
          if (numero !== undefined && numero !== null) {
            let formatado =
              parseFloat(numero)
                .toFixed(2)
                .replace('.', ',')
                .replace(/(\d)(?=(\d{3},|\d{6},|\d{9},))/g, '$1.')
            return formatado
          }
        } else {
          return value[campo] === 0 ? '0' : value[campo]
        }
      }

      return ' - '
    },
    exibir () {
      console.log(this.cadastroOriginal.imovel)
    },
    exibirValor (value, campo) {
      if (value) {
        return enumImovelReurb[campo][value]
      }
      return ' - '
    },
    exibirValores (values, campo) {
      if (values && values.length > 0) {
        return values.map(value => enumImovelReurb[campo][value])
      }
      return '-'
    },
    getEnderecoCompleto () {
      return `${this.cadastroOriginal.imovel?.endereco?.loteamentoVila ? this.cadastroOriginal.imovel?.endereco?.loteamentoVila + ',' : ''}
      ${this.cadastroOriginal.imovel?.endereco?.numero ? 'número ' + this.cadastroOriginal.imovel?.endereco?.numero + ',' : ''}
      ${this.cadastroOriginal.imovel?.endereco?.complemento ? this.cadastroOriginal.imovel?.endereco?.complemento + ',' : ''}
      ${this.cadastroOriginal.imovel?.endereco?.lote ? 'lote ' + this.cadastroOriginal.imovel?.endereco?.lote + ',' : ''}
      ${this.cadastroOriginal.imovel?.endereco?.quadra ? 'quadra ' + this.cadastroOriginal.imovel?.endereco?.quadra + ',' : ''}
      ${this.cadastroOriginal.imovel?.endereco?.bairro ? this.cadastroOriginal.imovel?.endereco?.bairro : ''}`
    },
    getPossuiMatricula () {
      if (this.cadastroOriginal?.imovel?.possuiMatricula == null) {
        return '-'
      }
      return this.cadastroOriginal.imovel.possuiMatricula ? 'Sim' : 'Não'
    }
  }

}
</script>

<style lang="scss" scoped>
.margin-top-10 {
  padding: 10px;
}
.text .text{
  color: #ff0000 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/informacoesCadastro/ma/InformacoesImovelReurb.vue